import { render, staticRenderFns } from "./CalendarOverview.vue?vue&type=template&id=6060e34f&"
import script from "./CalendarOverview.vue?vue&type=script&lang=ts&"
export * from "./CalendarOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports